import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import {HttpClient} from '@angular/common/http';
import {throwError as observableThrowError, Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {UtilsService} from "../utils/utils.service";

@Injectable()
export class UsuariosService {
  private apiUrl = environment.apiUrl;
  private usuariosEmpresaUrl = `${this.apiUrl}public/usuarios`;

  constructor(private _http: HttpClient, private _utils: UtilsService) {
  }

  getUsuarios(empresaId: number): Observable<any[]> {
    if (!empresaId) {
      empresaId = this._utils.getUsuario().empresa;
    }
    return this._http.get(this.usuariosEmpresaUrl + '/' + empresaId)
      .pipe(map((data) => {
        return <any>data;
      }));
  }

  getUsuariosUnicosComEmailMaisRectrix(empresaId: number): Observable<any[]> {
    if (!empresaId) {
      empresaId = this._utils.getUsuario().empresa;
    }
    return this._http.get(this.usuariosEmpresaUrl + '/unicosComEmail/maisRectrix/' + empresaId)
      .pipe(map((data) => {
        return <any>data;
      }));
  }

  private handleError(error) {
    console.log(error);
    return observableThrowError(error.error || 'Server error');
  }
}
